var _path, _path2, _path3, _path4, _path5, _path6, _path7, _polygon, _rect, _rect2, _polygon2, _polygon3, _polygon4, _rect3, _rect4, _polygon5, _polygon6, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _path8, _path9, _path10, _path11, _path12, _path13, _polygon7, _path14, _path15, _path16, _polygon8, _path17, _path18, _path19, _polygon9, _path20, _path21, _path22, _polygon10, _path23, _path24, _path25, _polygon11, _path26, _path27, _rect15, _rect16, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _polygon12, _path52, _path53, _rect17, _rect18, _path54, _path55, _path56, _path57, _path58, _rect19, _rect20, _path59, _path60, _path61, _path62, _path63, _polygon13, _polygon14, _path64, _path65, _path66, _ellipse, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _polygon15, _rect21, _rect22, _rect23, _rect24, _path82, _path83, _path84, _path85, _rect25, _rect26, _polygon16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaleChef(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 865.76,
    height: 682.89,
    viewBox: "0 0 865.76 682.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M811.64,436.51c-29.15,121.73-118.29,135-118.29,135-45.14,12.44-130-6.93-130-6.93-34.86-11.28-97.43-12.44-97.43-12.44-16.86.37-36.14,3.6-52.63,7.17-21.8,4.7-38.73,10-38.73,10-103.66,30.29-172.35,8.87-172.35,8.87-90.58-29.85-121.36-96.73-121.36-96.73C33.76,401,58.21,311.28,58.21,311.28c17.58-87.74,90.34-135.15,90.34-135.15,106.32-70.54,224-37.82,231.82-35.52l.42.13c55,13.64,128.28-6.94,128.28-6.94s157.14-42.21,243.14,33.53c41.14,36.24,29.22,91.14,26.21,104.64a41.86,41.86,0,0,0-1.07,8.33,94.85,94.85,0,0,0,19.26,59,27.91,27.91,0,0,1,2.58,3.8C821.77,384,811.64,436.51,811.64,436.51Z",
    fill: "#10b981"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M811.64,436.51c-10.75,44.87-29.64,75-49.22,95.17a153.47,153.47,0,0,1-15,13.54l-.44.36c-1.26,1-2.52,1.95-3.76,2.86-.55.41-1.11.81-1.66,1.2-2.16,1.55-4.3,3-6.4,4.33-.83.53-1.66,1-2.48,1.55-.51.32-1,.62-1.53.92l-1.06.62-1.22.71q-3.36,1.9-6.52,3.48c-16.83,8.45-29,10.26-29,10.26-45.14,12.44-130-6.93-130-6.93-3.79-1.23-7.91-2.33-12.24-3.33-5.35-1.24-11-2.31-16.8-3.23-2.08-.33-4.18-.65-6.28-.95a584.79,584.79,0,0,0-62.11-4.93c-2.58.06-5.22.18-7.89.37-14.8,1-30.77,3.78-44.74,6.8-21.8,4.7-38.73,10-38.73,10-103.66,30.29-172.35,8.87-172.35,8.87-90.58-29.85-121.36-96.73-121.36-96.73C33.76,401,58.21,311.28,58.21,311.28c17.58-87.74,90.34-135.15,90.34-135.15,106.32-70.54,224-37.82,231.82-35.52l.42.13c55,13.64,128.28-6.94,128.28-6.94s5.06-1.36,13.86-3.16c3-.6,6.44-1.27,10.26-1.94,3-.53,6.23-1.07,9.67-1.6,24.72-3.8,60.3-7.12,97.36-3.39,6.58.65,13.2,1.53,19.81,2.67q6,1,12,2.36c28.91,6.43,57.11,18.26,80.19,38.59,31,27.29,31.87,65.15,29.14,88-.48,4-1.08,7.58-1.64,10.53-.49,2.53-1,4.61-1.29,6.15a41.86,41.86,0,0,0-1.07,8.33,95.37,95.37,0,0,0,.43,11c.07.7.15,1.39.23,2.08.36,3,.85,5.86,1.45,8.61a95.34,95.34,0,0,0,5.24,16.66,89.63,89.63,0,0,0,11.91,20.67,27.91,27.91,0,0,1,2.58,3.8C821.77,384,811.64,436.51,811.64,436.51Z",
    fill: "#fff",
    opacity: 0.7,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.64,436.51c-10.74,44.82-29.6,74.93-49.16,95.1l-.06.07a153.47,153.47,0,0,1-15,13.54l-.44.36c-1.26,1-2.52,1.95-3.76,2.86-.55.41-1.11.81-1.66,1.2-2.16,1.55-4.3,3-6.4,4.33l-64.11-33.43V293.68H776.92l1.09-.33a94.65,94.65,0,0,0,18.6,45.94,27.91,27.91,0,0,1,2.58,3.8,106.5,106.5,0,0,1,8.5,20.26C818.79,399.46,811.64,436.51,811.64,436.51Z",
    fill: "#e6e6e6",
    style: {
      isolation: "isolate"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M811.64,436.51c-10.74,44.82-29.6,74.93-49.16,95.1l-.13-.07-75-26.17v-152l120.34,10C818.79,399.46,811.64,436.51,811.64,436.51Z",
    fill: "#fff",
    opacity: 0.41
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M534.31,547.39V558c-2.08-.33-4.18-.65-6.28-.95a584.79,584.79,0,0,0-62.11-4.93c-2.58.06-5.22.18-7.89.37v-42l3.79-1.23Z",
    fill: "#ccc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M732.8,555.46c-3.62,2.21-7.12,4.13-10.43,5.79-16.83,8.45-29,10.26-29,10.26-45.14,12.44-130-6.93-130-6.93-3.79-1.23-7.91-2.33-12.24-3.33-5.35-1.24-11-2.31-16.8-3.23v-3.2L731.49,551Z",
    fill: "#b3b3b3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M762.42,531.68A155.37,155.37,0,0,1,747,545.58l-212.69,1.81s-81.54-53.74-82.22-54.5l175-6.86,135.27,45.51Z",
    fill: "#ccc"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M747.44,545.22l-.44.36c-1.26,1-2.52,1.95-3.76,2.86-.55.41-1.11.81-1.66,1.2-3,2.17-6,4.12-8.88,5.88-.51.32-1,.62-1.53.92l-1.06.62-1.22.71q-3.36,1.9-6.52,3.48H551.11c-5.35-1.24-11-2.31-16.8-3.23V547.39Z",
    fill: "#999"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M534.31,547.39V558c-2.08-.33-4.18-.65-6.28-.95l-76.72-51,.78-13.14Z",
    fill: "#b3b3b3"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "654.46 526.95 759.84 526.95 688.04 491.59 611.83 491.59 591.87 492.89 654.46 526.95",
    fill: "#2f2e41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 654.46,
    y: 526.95,
    width: 105.39,
    height: 4.59,
    fill: "#2f2e41"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 654.46,
    y: 526.95,
    width: 105.39,
    height: 4.59,
    opacity: 0.2
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "654.46 531.54 601.83 502.37 608.64 502.02 654.46 526.95 654.46 531.54",
    fill: "#2f2e41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "654.46 531.54 601.83 502.37 608.64 502.02 654.46 526.95 654.46 531.54",
    opacity: 0.3
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "475.43 489.46 534.3 526.03 640.18 526.03 561.64 486.03 475.43 489.46",
    fill: "#2f2e41"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 534.3,
    y: 526.03,
    width: 105.88,
    height: 5.51,
    fill: "#2f2e41"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 534.3,
    y: 526.03,
    width: 105.88,
    height: 5.51,
    opacity: 0.2
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "475.43 489.46 475.43 494.12 534.3 531.54 534.3 526.03 475.43 489.46",
    fill: "#2f2e41"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "475.43 489.46 475.43 494.12 534.3 531.54 534.3 526.03 475.43 489.46",
    opacity: 0.3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 405.34,
    y: 192.01,
    width: 147.72,
    height: 171.55,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 398.09,
    y: 192.01,
    width: 7.25,
    height: 171.55,
    fill: "#e6e6e6",
    style: {
      isolation: "isolate"
    }
  }), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 414.44,
    y: 210.28,
    width: 74.69,
    height: 10.72,
    fill: "#10b981",
    opacity: 0.22
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 414.44,
    y: 231.33,
    width: 126.72,
    height: 6.75,
    fill: "#10b981",
    opacity: 0.22
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 414.44,
    y: 247.01,
    width: 126.72,
    height: 6.75,
    fill: "#10b981",
    opacity: 0.22
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 414.44,
    y: 278.38,
    width: 126.72,
    height: 6.75,
    fill: "#10b981",
    opacity: 0.22
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 414.44,
    y: 293.68,
    width: 126.72,
    height: 6.75,
    fill: "#10b981",
    opacity: 0.22
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 414.44,
    y: 310.06,
    width: 126.72,
    height: 6.75,
    fill: "#10b981",
    opacity: 0.22
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 414.44,
    y: 324.83,
    width: 126.72,
    height: 6.75,
    fill: "#10b981",
    opacity: 0.22
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 414.44,
    y: 341.58,
    width: 126.72,
    height: 6.75,
    fill: "#10b981",
    opacity: 0.22
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 414.44,
    y: 262.69,
    width: 126.72,
    height: 6.75,
    fill: "#10b981",
    opacity: 0.22
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M777.35,280.3a95.37,95.37,0,0,0,.43,11l-.86,2.41H671.07L517.21,132.25l5.72-1.61,9.56-2.68.7.74L664.64,267.46l100.28-.85-124.7-142.9-.43-.5,20.13,3,.11.13L779.71,265.82c-.49,2.53-1,4.61-1.29,6.15A41.86,41.86,0,0,0,777.35,280.3Z",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M413.29,350.16V559.31c-21.8,4.7-38.73,10-38.73,10-103.66,30.29-172.35,8.87-172.35,8.87-51.64-17-83.85-46.07-102-67.91a182.92,182.92,0,0,1-11.83-15.86,111,111,0,0,1-7.54-13Q76.51,474,73,466.54c-2.29-4.79-4.34-9.6-6.19-14.4a216.82,216.82,0,0,1-10.41-36.43c-1.24-6.33-2.18-12.55-2.87-18.6-5.52-48.28,4.71-85.83,4.71-85.83a196.63,196.63,0,0,1,11.33-37A213.11,213.11,0,0,1,84.17,245.5c27.59-45.4,64.38-69.37,64.38-69.37,106.32-70.54,224-37.82,231.82-35.52l.46,209.55Z",
    fill: "#e6e6e6",
    style: {
      isolation: "isolate"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M371.62,415.71v50.83H73c-2.29-4.79-4.34-9.6-6.19-14.4V415.71Z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M418.21,499v6.68a4.58,4.58,0,0,1-4.59,4.59H100.22a182.92,182.92,0,0,1-11.83-15.86H413.62A4.59,4.59,0,0,1,418.21,499Z",
    fill: "#999"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M109.82,442v43.16a2.09,2.09,0,0,1-2.09,2.09h-18a2.09,2.09,0,0,1-2.09-2.09V442a.85.85,0,0,1,.85-.85h2.09V439h2V437.1H95l2.17-15.63h1.63l2.86,15.63h2.32V439h1.85v2.17H109A.85.85,0,0,1,109.82,442Z",
    fill: "#10b981"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M109.82,442v43.16a2.09,2.09,0,0,1-2.09,2.09h-18a2.09,2.09,0,0,1-2.09-2.09v-2.24c22.28-8.2,20.12-41.77,20.12-41.77H109A.85.85,0,0,1,109.82,442Z",
    opacity: 0.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M95,437.1h6.66l-2.86-15.63.55,11.2a3.77,3.77,0,0,1-2.39,3.67Z",
    opacity: 0.2
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "105.79 441.12 95.49 440.81 105.79 440.2 105.79 441.12",
    opacity: 0.2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M176.65,447.35v38a2,2,0,0,1-2.09,1.84H156.61a2,2,0,0,1-2.09-1.84v-38a.8.8,0,0,1,.85-.75h2.09v-1.92h2v-1.63h2.32L164,429.28h1.63l2.86,13.77h2.32v1.63h1.85v1.92h3.18A.8.8,0,0,1,176.65,447.35Z",
    fill: "#10b981"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M176.65,447.35v38a2,2,0,0,1-2.09,1.84H156.61a2,2,0,0,1-2.09-1.84v-2c22.28-7.22,20.12-36.8,20.12-36.8h1.16A.8.8,0,0,1,176.65,447.35Z",
    opacity: 0.3
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M161.79,443.05h6.66l-2.86-13.77.55,9.87a3.32,3.32,0,0,1-2.39,3.23Z",
    opacity: 0.3
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "172.62 446.6 162.32 446.32 172.62 445.79 172.62 446.6",
    opacity: 0.3
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M202.56,447.35v38a1.87,1.87,0,0,1-1.89,1.84H184.42a1.87,1.87,0,0,1-1.89-1.84v-38a.75.75,0,0,1,.76-.75h1.9v-1.92H187v-1.63h2.1l2-13.77h1.48l2.59,13.77h2.1v1.63h1.67v1.92h2.88A.75.75,0,0,1,202.56,447.35Z",
    fill: "#10b981"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M202.56,447.35v38a1.87,1.87,0,0,1-1.89,1.84H184.42a1.87,1.87,0,0,1-1.89-1.84v-2c20.17-7.22,18.21-36.8,18.21-36.8h1A.75.75,0,0,1,202.56,447.35Z",
    opacity: 0.2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M189.11,443.05h6l-2.59-13.77.49,9.87a3.29,3.29,0,0,1-2.16,3.23Z",
    opacity: 0.2
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "198.91 446.6 189.58 446.32 198.91 445.79 198.91 446.6",
    opacity: 0.2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M141.06,443.49V485.2a2.18,2.18,0,0,1-2.32,2h-20a2.18,2.18,0,0,1-2.32-2V443.49a.88.88,0,0,1,.94-.82h2.33v-2.1h2.24v-1.79h2.58l2.42-15.1h1.82l3.18,15.1h2.58v1.79h2.06v2.1h3.55A.88.88,0,0,1,141.06,443.49Z",
    fill: "#10b981"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M141.06,443.49V485.2a2.18,2.18,0,0,1-2.32,2h-20a2.18,2.18,0,0,1-2.32-2V483c24.81-7.92,22.4-40.36,22.4-40.36h1.3A.88.88,0,0,1,141.06,443.49Z",
    opacity: 0.2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M124.51,438.78h7.42l-3.18-15.1.6,10.82a3.65,3.65,0,0,1-2.65,3.55Z",
    opacity: 0.2
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "136.57 442.67 125.1 442.37 136.57 441.78 136.57 442.67",
    opacity: 0.2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M164.21,457.65v28.2a1.6,1.6,0,0,1-1.76,1.37H147.37a1.6,1.6,0,0,1-1.76-1.37v-28.2a.65.65,0,0,1,.72-.56h1.75v-1.42h1.69v-1.21h1.95l1.82-10.21h1.37l2.41,10.21h2v1.21h1.55v1.42h2.67A.65.65,0,0,1,164.21,457.65Z",
    fill: "#10b981"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M164.21,457.65v28.2a1.6,1.6,0,0,1-1.76,1.37H147.37a1.6,1.6,0,0,1-1.76-1.37v-1.46c18.72-5.36,16.91-27.3,16.91-27.3h1A.65.65,0,0,1,164.21,457.65Z",
    opacity: 0.2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M151.72,454.46h5.6l-2.41-10.21.46,7.32a2.5,2.5,0,0,1-2,2.4Z",
    opacity: 0.2
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "160.82 457.09 152.16 456.89 160.82 456.49 160.82 457.09",
    opacity: 0.2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M187.11,504.14s-3.87,44-4.94,67.5c0,0,15.55,5.59,20,6.61,0,0,3.37-58.82,6.57-71.14C208.78,507.11,196.92,505.07,187.11,504.14Z",
    fill: "#2f2e41"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M418.21,401.69v9.43a4.59,4.59,0,0,1-4.59,4.59H56.37c-1.24-6.33-2.18-12.55-2.87-18.6H413.62A4.58,4.58,0,0,1,418.21,401.69Z",
    fill: "#999"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 66.78,
    y: 306.25,
    width: 300,
    height: 43.91,
    fill: "#fff"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 66.78,
    y: 306.25,
    width: 300,
    height: 16.51,
    fill: "#ccc"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M366.78,245.5v47.89s-20.57-14.14-76.29-16.28L69.54,274.26A213.11,213.11,0,0,1,84.17,245.5Z",
    fill: "#ccc"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M122.06,237.68l-37.28,3s2.58,21.42,6.43,33.85l39.85-5.08S121.21,253.11,122.06,237.68Z",
    fill: "#fff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M139.63,235.11l36.52,5.14s-1.37,23,2.06,31.86H139.63S135.78,258.68,139.63,235.11Z",
    fill: "#fff"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M300.21,523.39l-91.43-16.28s-13.44-.92-22.42-3.14a3.35,3.35,0,0,1-2.46-3.86l16-86.43-16-162.57s-1.43-7.15,27.71-18l31.72-14s7.56-4.69,14.12-4.35l9.24-1.83a6.74,6.74,0,0,1,1.92-3.06A3,3,0,0,1,273,210l2.84,3,18.43,18.33-1.93,10.5L306,245.5s.31-10.72,7.15-15.64a2.9,2.9,0,0,1,4.59,1.95l1.65,12.83,32.21,27.47-3.42,70.14L300.78,522",
    fill: "#10b981"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M300.21,523.39l-91.43-16.28s-13.44-.92-22.42-3.14a3.35,3.35,0,0,1-2.46-3.86l16-86.43-16-162.57s-1.43-7.15,27.71-18l31.72-14s7.56-4.69,14.12-4.35l9.24-1.83a6.74,6.74,0,0,1,1.92-3.06A3,3,0,0,1,273,210l2.84,3,18.43,18.33-1.93,10.5L306,245.5s.31-10.72,7.15-15.64a2.9,2.9,0,0,1,4.59,1.95l1.65,12.83,32.21,27.47-3.42,70.14L300.78,522",
    fill: "#fff",
    opacity: 0.2
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M261.08,278.26l-3.61-63.5,9.24-1.83,15.81,65.33s.46,6.38,8.67,8.06c0,0,10.64,4.1,35.88,3l-11.4-41.82,3.75-2.9,5,4.24a458.21,458.21,0,0,1,15.46,48.69s5.62,17.74,8.36,44.68l-1,70s4.67,69.19,7.56,92.91L361,572.61s-77.93,24.78-158.78,5.64c0,0,3-57.29,8.57-86.86,0,0,1.5-63-4.29-81l15.67-47.81,34-66.91A29.06,29.06,0,0,0,261.08,278.26Z",
    fill: "#10b981"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M256.21,295.68,243.63,338s-10,22.86,8.86,35.15l40.29,26,50.64,46s-6.43,6.41-16.93,3c0,0-6.86,8.42-28.5-1.58L280.42,437l-70.67-4.43s-.69-13.34-3.26-22.13l15.67-47.81Z",
    opacity: 0.2
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M170.26,414a29.83,29.83,0,0,0,11.79-4.75l-5.9-2.47a25.2,25.2,0,0,0-3.23,3.28A24.38,24.38,0,0,0,170.26,414Z",
    fill: "#10b981"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M170.26,414a29.83,29.83,0,0,0,11.79-4.75l-5.9-2.47c-.73.68-1.48,1.43-2.23,2.28A33.36,33.36,0,0,0,170.26,414Z",
    fill: "#fff",
    opacity: 0.35
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M280.47,186.45,275.81,213l18.43,18.33-1.93,10.5L306,245.5s1.28-11.47,6.43-14.89l.54-13.37-31.7-31.32Z",
    fill: "#f9b499"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M229.56,369.8s-33.09,9.79-59.3,44.21c0,0-30.18-37.86-22.5-56.92l36.16-106s30.35,20.77,31.58,68.26a14.82,14.82,0,0,1-.32,3.39l-5.74,27.45Z",
    fill: "#10b981"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M229.56,369.8s-33.09,9.79-59.3,44.21c0,0-30.18-37.86-22.5-56.92l36.16-106s30.35,20.77,31.58,68.26a14.82,14.82,0,0,1-.32,3.39l-5.74,27.45Z",
    fill: "#fff",
    opacity: 0.3
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M229.56,369.8l-19.33-14.3c-9.41-7.06-34,10.9-34.67,11.37,12.71-13.49,30.17-16.66,30.17-16.66l9.45-27.45-5.74,27.45Z",
    fill: "#fff",
    opacity: 0.3
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M393.36,373.11s-24.33,4.37-32.78,31.71a60.17,60.17,0,0,0-1.77,7.39s-9.53,3-11.62-3.57l.66-42.89.36-23.5,3.42-70.14,19.69,87.38a8.51,8.51,0,0,1,4.17,6.26Z",
    fill: "#10b981"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M393.36,373.11s-24.33,4.37-32.78,31.71a60.17,60.17,0,0,0-1.77,7.39s-9.53,3-11.62-3.57l.66-42.89.36-23.5,3.42-70.14,19.69,87.38a8.51,8.51,0,0,1,4.17,6.26Z",
    fill: "#fff",
    opacity: 0.3
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M360.58,404.82a60.17,60.17,0,0,0-1.77,7.39s-9.53,3-11.62-3.57l.66-42.89,3.78,10.72s5.69-5.06,11.94-5.36C363.57,371.11,338.22,395.64,360.58,404.82Z",
    fill: "#fff",
    opacity: 0.3
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M358.81,412.21s8.64-2,13.11-6.14l-11.34-1.25A42.7,42.7,0,0,0,358.81,412.21Z",
    fill: "#10b981"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M358.81,412.21s8.64-2,13.11-6.14l-11.34-1.25A42.7,42.7,0,0,0,358.81,412.21Z",
    fill: "#fff",
    opacity: 0.35
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M410.91,502.05,385.1,517.54a4.92,4.92,0,0,1-6.88-1.94l-3.66-7-13.47-25.92a3.31,3.31,0,0,1,1.28-4.4l7.49-4.34a1.91,1.91,0,0,0,.62-2.71l-62.67-92.25a6.08,6.08,0,0,1,5-9.47h.23a6.07,6.07,0,0,1,4.89,2.8l59.86,94.12a3.66,3.66,0,0,0,4.66,1.34l5.77-2.74a3.32,3.32,0,0,1,4.15,1.1l5.7,8.24,9.77,14.12,4.56,6.59A4.91,4.91,0,0,1,410.91,502.05Z",
    fill: "#b3b3b3"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M410.91,502.05,385.1,517.54a4.92,4.92,0,0,1-6.88-1.94l-3.66-7,33.3-20.1,4.56,6.59A4.91,4.91,0,0,1,410.91,502.05Z",
    fill: "#ccc"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M398.09,474.34l-6.55-5.76a3.92,3.92,0,0,0-4.06-.69l-7,2.78a3.67,3.67,0,0,1-4.46-1.44l-63-99.75a6.07,6.07,0,0,1,4.89,2.8l59.86,94.12a3.66,3.66,0,0,0,4.66,1.34l5.77-2.74a3.32,3.32,0,0,1,4.15,1.1Z",
    opacity: 0.2
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M360.58,404.82l61.7,7.39,45.79,3.5s1.62-4.9-3.7-10.89l-8.79-10.16s-1.85-4.16-13.41-3.7c0,0-9,.41-12.72-1.64l-36.09-16.21S369.65,376.35,360.58,404.82Z",
    fill: "#f9b499"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M445.64,403.82s8.5-7.48,11.28,6.25Z",
    fill: "#f7a48b"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M476.61,429.08a6.18,6.18,0,0,1-1.18,1.36h0a6.41,6.41,0,0,1-6.81,1L403.24,402.1a9.55,9.55,0,0,1-5.1-11.9,10,10,0,0,1,.85-1.78,9.54,9.54,0,0,1,12.82-3.37l62.55,35a6.18,6.18,0,0,1,1.81,1.51,6.39,6.39,0,0,1,.44,7.56Z",
    fill: "#2f2e41"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "380.79 332.87 380.83 350.16 413.29 350.16 380.79 332.87",
    fill: "#ccc"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M476.61,429.08a6.18,6.18,0,0,1-1.18,1.36h0a6.41,6.41,0,0,1-6.81,1L403.24,402.1a9.55,9.55,0,0,1-5.1-11.9c1.14,2,3.95,4.58,10.6,6.95l58.47,24.76s6,1.89,9-.39a6.39,6.39,0,0,1,.44,7.56Z",
    opacity: 0.2
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M573.05,409.61V482.8a13,13,0,0,1-13,13H499.87a13,13,0,0,1-13-13V409.61Z",
    fill: "#b3b3b3"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 523.99,
    y: 401.96,
    width: 12.38,
    height: 5.15,
    fill: "#b3b3b3"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 520.69,
    y: 394.41,
    width: 18.98,
    height: 8.82,
    rx: 2.49,
    fill: "#ccc"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M573.05,409.61V482.8a13,13,0,0,1-13,13H499.87a13,13,0,0,1-11.7-7.31h29.68c42-3,38.87-78.88,38.87-78.88Z",
    opacity: 0.2
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M576,403.23h5.17a1.4,1.4,0,0,1,1.4,1.4v2.48a0,0,0,0,1,0,0h-8a0,0,0,0,1,0,0v-2.48A1.4,1.4,0,0,1,576,403.23Z",
    fill: "#ccc"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M573.05,411.73s3.59-.13,3.71-4.62h2.79s.54,6-6.5,7.65Z",
    fill: "#b3b3b3"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M477.36,403.23h8a0,0,0,0,1,0,0v2.48a1.4,1.4,0,0,1-1.4,1.4h-5.17a1.4,1.4,0,0,1-1.4-1.4v-2.48a0,0,0,0,1,0,0Z",
    transform: "translate(962.68 810.34) rotate(-180)",
    fill: "#ccc"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M486.89,411.73s-3.59-.13-3.71-4.62h-2.79s-.54,6,6.5,7.65Z",
    fill: "#b3b3b3"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 641.65,
    y: 375.47,
    width: 15.3,
    height: 6.37,
    fill: "#b3b3b3"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 637.57,
    y: 366.13,
    width: 23.46,
    height: 10.92,
    rx: 2.49,
    fill: "#ccc"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M705.63,377h7.06a1.4,1.4,0,0,1,1.4,1.4v3.4a0,0,0,0,1,0,0h-9.86a0,0,0,0,1,0,0v-3.4A1.4,1.4,0,0,1,705.63,377Z",
    fill: "#ccc"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M702.3,387.56s4.44-.16,4.59-5.72h3.44s.68,7.44-8,9.48Z",
    fill: "#b3b3b3"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M584,377h9.86a0,0,0,0,1,0,0v3.4a1.4,1.4,0,0,1-1.4,1.4H585.4a1.4,1.4,0,0,1-1.4-1.4V377A0,0,0,0,1,584,377Z",
    transform: "translate(1177.85 758.89) rotate(-180)",
    fill: "#ccc"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M595.78,387.56s-4.43-.16-4.59-5.72h-3.44s-.67,7.44,8,9.48Z",
    fill: "#b3b3b3"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M784.7,318.62l-99.92-1.81V305l8.57-3h86.11A95.34,95.34,0,0,0,784.7,318.62Z",
    fill: "#ccc"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "532.49 127.96 543.53 127.96 669.78 261.25 664.63 267.46 532.49 127.96",
    fill: "#b3b3b3"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "760.07 261.04 669.78 261.25 664.63 267.46 764.92 266.61 760.07 261.04",
    fill: "#999"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M271.74,183.48s2.2,9.78,7.24,11.49l1.49-8.52S275.91,189.93,271.74,183.48Z",
    fill: "#2f2e41"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M781.35,255.29c-.48,4-1.08,7.58-1.64,10.53L660,126.38l-.11-.13,11.15,1.39.95,1.1Z",
    fill: "#b3b3b3"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M312.64,226l.36-8.77-27.22-24S281.37,220,312.64,226Z",
    fill: "#f7a48b"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 311.66,
    cy: 170.51,
    rx: 47.13,
    ry: 31.7,
    transform: "translate(114.52 466.05) rotate(-84.98)",
    fill: "#f9b499"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M285.78,175.36c0,6.54-3.64,11.84-8.14,11.84s-8.13-5.3-8.13-11.84a16.41,16.41,0,0,1,.41-3.71c1.07-4.72,4.12-8.12,7.72-8.12s6.66,3.4,7.73,8.12A16.41,16.41,0,0,1,285.78,175.36Z",
    fill: "#f9b499"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M343.15,160.26s-1.67-11.6-3.23-13.19c0,0-.43-.47-1.27.23a7.39,7.39,0,0,1-4,1.74c-5.24.42-15.81.29-24.08-6,0,0-2.24,8.59-12,7a4,4,0,0,0-3.93,1.56,16.64,16.64,0,0,0-2.59,7.59,13.29,13.29,0,0,1-6.62,12.4c-1.07-4.72-4.12-8.12-7.73-8.12s-6.65,3.4-7.72,8.12c0,0-.75-13.36,2.36-21.18,0,0-8.55-1.08-1.22-6.86,0,0,60.86-6.54,77.72,2.36C348.78,146,353,155.27,343.15,160.26Z",
    fill: "#2f2e41"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M348.87,115.12a14.1,14.1,0,0,1-3,5.38s1.67,4.8,2.47,13.95a.5.5,0,0,1,0,.12c.05.59.1,1.2.14,1.83.2,2.83.3,6,.26,9.57,0,0-10.43-7.41-77.72-2.36a83.92,83.92,0,0,1,.14-8.94c.3-4.54,1-10,2.73-14.25,0,0-9-9.86,0-16.59,0,0,5.16-4.93,9.42,0a20.16,20.16,0,0,1,8.16-5.58c4.55-1.59,10.65-1.49,17.37,4.69a17.86,17.86,0,0,1,13.72-2.86,24.26,24.26,0,0,1,11,5.55,8,8,0,0,1,1.36-1.1,8.92,8.92,0,0,1,10.42.29h0A9.45,9.45,0,0,1,348.87,115.12Z",
    fill: "#10b981"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M348.78,146s-10.43-7.41-77.72-2.36a83.92,83.92,0,0,1,.14-8.94c11.21-1.58,50.33-6.23,77.32,1.73C348.72,139.23,348.82,142.42,348.78,146Z",
    opacity: 0.2
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M348.87,115.12a14.1,14.1,0,0,1-3,5.38s1.67,4.8,2.47,13.95c-2.42-20.44-43.78-15.5-45.59-15.28a86.91,86.91,0,0,1,35.25-.54,7.68,7.68,0,0,0,6.78-1.76c4.77-4.46.54-12,.54-12A9.45,9.45,0,0,1,348.87,115.12Z",
    opacity: 0.2
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M322.6,100.08h0c-13.75.62-14.91,7.4-14.91,7.4-1.64-10.47-16.18-9.24-16.18-9.24,4.55-1.59,10.65-1.49,17.37,4.69A17.86,17.86,0,0,1,322.6,100.08Z",
    opacity: 0.2
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M229.56,369.8l63.22,29.31s22.38,2.16,30.85,3.14c0,0,6.29,9.82,10.58,14l23,20.6a1.77,1.77,0,0,1-.17,2.79,9.67,9.67,0,0,1-9.88.89s2.68,8.35-10.7,2.58c0,0,.29,6.57-12,3.42,0,0-3.14,6.86-13.43-.57,0,0-2.85,0-12.28-7.14l-16-14.29s-88.46-6.87-106.63-17.74C176.15,406.79,194.91,382.49,229.56,369.8Z",
    fill: "#f9b499"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M326.49,424.53a167,167,0,0,1,20.7,16,167.77,167.77,0,0,1-20.7-16Z",
    fill: "#f7a48b"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M321.35,433.68c5.15,3.06,9.79,6.74,15.14,9.43-5.86-1.39-10.88-5.31-15.14-9.43Z",
    fill: "#f7a48b"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M315.06,440.53c2.81,1.75,6.83,4,9.43,6a17.65,17.65,0,0,1-9.43-6Z",
    fill: "#f7a48b"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M336,400.68l13.5,21.23S345.12,406.3,336,400.68Z",
    fill: "#f9b499"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M436.15,428.43s-4.62,3.7-8.78-2.55l-5.09-13.67s.07-3.26,4.35.67c0,0,1.72-4.28,5.66.71a.18.18,0,0,0,.33-.13c-.21-1.48-.18-4.44,3.53-3.85,0,0,2-4.56,6.91,0,0,0,1.29-5.65,6.29.78l11.82,16.46A3.33,3.33,0,0,1,461,431c-1.48,1.7-4.15,3.36-8.26,1,0,0-5.15,3.69-9.43-.88C443.35,431.11,439.68,432.18,436.15,428.43Z",
    fill: "#f9b499"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M426.92,414.07a70.58,70.58,0,0,1,9.23,14.36,71.29,71.29,0,0,1-9.23-14.36Z",
    fill: "#f7a48b"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M432.62,413.46a103.78,103.78,0,0,1,10.73,17.65,103.92,103.92,0,0,1-10.73-17.65Z",
    fill: "#f7a48b"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M436.15,409.61A191.08,191.08,0,0,1,452.78,432a190.24,190.24,0,0,1-16.63-22.38Z",
    fill: "#f7a48b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M760.07,261.05l-90.29.2L543.54,128l-.68-.86c24.72-3.8,60.3-7.12,97.36-3.39Z",
    fill: "#fff",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "595.75 384.94 635.87 378.75 662.87 378.75 702.31 384.94 595.75 384.94",
    fill: "#ccc"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 682.74,
    y: 488.5,
    width: 10.61,
    height: 4.4,
    fill: "#b3b3b3"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 660.52,
    y: 488.5,
    width: 13.96,
    height: 6.18,
    fill: "gray"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 620.1,
    y: 487.26,
    width: 13.96,
    height: 6.86,
    fill: "gray"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 643.59,
    y: 486.03,
    width: 10.87,
    height: 6.86,
    fill: "#b3b3b3"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M702.3,384.94V475.5a16.07,16.07,0,0,1-16.07,16.09h-74.4a16.08,16.08,0,0,1-16.09-16.09V384.94Z",
    fill: "#b3b3b3"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M702.3,384.94V475.5a16.07,16.07,0,0,1-16.07,16.09h-74.4a16.08,16.08,0,0,1-14.47-9h36.7c51.91-3.73,48.05-97.6,48.05-97.6Z",
    opacity: 0.2
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M505.21,462.25s21.86-2.77,58.26,6.06c0,0,44,8.46,53.81,21.8L609.6,498l-69-8.83-23.43-10.63-7.56-7.93L504,466.77Z",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M617.28,490.11a17.8,17.8,0,0,1-5.57,9.65c-3.61,3.28-9.51,6-19.08,5.56,0,0-44.78-3.64-76.5-17.57,0,0-18-6.54-18-22.66l-.42-23.41-22.28-11.24a6.18,6.18,0,0,0,1.18-1.36,6.66,6.66,0,0,0,.49-.91,6.41,6.41,0,0,0,.49-3.38h.05l25.76,12.68,1.81,24.77S508,472.11,527.92,479C527.92,479,596.28,501.25,617.28,490.11Z",
    fill: "#e6e6e6",
    style: {
      isolation: "isolate"
    }
  }), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M611.71,499.76c-3.61,3.28-9.51,6-19.08,5.56,0,0-44.78-3.64-76.5-17.57,0,0-18-6.54-18-22.66l-.42-23.41-22.28-11.24a6.18,6.18,0,0,0,1.18-1.36,6.66,6.66,0,0,0,.49-.91l22.75,11.58L501.78,467s1.28,12.21,29.57,21.64C531.35,488.61,587.07,505.55,611.71,499.76Z",
    opacity: 0.08
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 681.06,
    y: 492.25,
    width: 13.96,
    height: 6.86,
    fill: "gray"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 642.04,
    y: 492.25,
    width: 13.96,
    height: 6.86,
    fill: "gray"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "486.86 409.61 519.31 404.61 541.16 404.61 573.05 409.61 486.86 409.61",
    fill: "#ccc"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleChef);
export default __webpack_public_path__ + "static/media/Male-chef.91b8205cabd4405f5650429a24f0de80.svg";
export { ForwardRef as ReactComponent };